export enum Role {
  ADMIN = 'ADMIN',
  COMPANY_ADMIN = 'COMPANY_ADMIN',
  COMPANY_USER = 'COMPANY_USER',
  COMPANY_OWNER = 'COMPANY_OWNER'
}
